/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Directive, TemplateRef } from '@angular/core';

import { TabDirective } from './tab.directive';

@Directive({
  selector: '[fmTabHeading]'
})
export class TabHeadingDirective {
  public templateRef: TemplateRef<any>;

  constructor(templateRef: TemplateRef<any>, tab: TabDirective) {
    tab.headingRef = templateRef;
  }
}
